import { BoxProps } from 'UIKit/Box/types'
import { InhouseGameDetails } from 'config/types/game'
import { StyledGameBoard } from 'views/InhouseGame/components/styled'
import { GameInHouseConfig } from 'views/InhouseGame/config/types'
import { WheelGameRiskEnum } from '../../config'
import { WheelSegments } from '../../config/types'
import WheelGameGraphic from './components/WheelGameGraphic'
import WheelPayoutGroup from './components/WheelPayoutGroup'
import WheelResultHistory from './components/WheelResultHistory'

const GameBoard: React.FC<
  {
    game: InhouseGameDetails
    risk: WheelGameRiskEnum
    segments: WheelSegments
  } & GameInHouseConfig &
    BoxProps
> = ({ risk, segments, volumeEnable, game, ...props }) => {
  return (
    <StyledGameBoard {...props}>
      <WheelResultHistory game={game} />
      <WheelGameGraphic volumeEnable={volumeEnable} segments={segments} risk={risk} />
      <WheelPayoutGroup
        padding={['0px 0px', '', '0px 28px', '0px 48px', '0px 28px', '0px 32px', , '0px 64px']}
        risk={risk}
        segments={segments}
      />
    </StyledGameBoard>
  )
}

export default GameBoard
